export default function MeasurementsListComponent(opts={}){
    BaseConstructor.call(this)
    let {container,measurements} = opts
    let elements = {}
    let context = this

    init()

    function init(){
        elements.container = context.createElement('div', '', '')
        elements.table_container = context.createElement('div', '', '')
        $(elements.container).append(elements.table_container)
    }

    this.generate = () =>{

        generateListItems()

        return elements.container
    }

    this.update = (new_measurements) =>{
        if(new_measurements){
            measurements = new_measurements
        }
        this.generate()

        return elements.container
    }

    const generateListItems = _ =>{
        clearTable()
        measurements.forEach((measurement,index)=>{
            let diff 
            if(measurements[index+1] && measurements[index+1].value_flu){
                diff = ((measurement.value_flu - measurements[index+1].value_flu)/100).toFixed(3)
            }
            let l = new listItem({container: elements.table_container, measurement:measurement, diff:diff})
            $(elements.table_container).append(l.generate())
        })
    }

    const clearTable = _ =>{
        elements.table_container.innerHTML = ''
    }


    const listItem = function(opts={}){
        let elements = {}
        let {measurement,diff} = opts

        this.generate = () =>{
            elements.container = document.createElement('div')
            $(elements.container).append(`<div class='flex flex-h-space-between'><div>${new Date(measurement.date).toLocaleTimeString()}</div><div>${(measurement.value_flu/100).toFixed(3)} m</div>${buildDiffItem(measurement,diff)}</div>`)
            return elements.container
        }

    }

    const buildDiffItem = (measurement, diff) =>{
        let klass = diff > 0 ? 'text-success' : diff < 0 ? 'text-danger' : ''
        let icon = diff > 0 ? 'fas fa-long-arrow-alt-up' : diff < 0 ? 'fas fa-long-arrow-alt-down' : ''
        return `<div class='${klass}'>${diff||""} <i class='${icon}'></i></div>`
    }
}

MeasurementsListComponent.prototype = Object.create(BaseConstructor.prototype)